import {useLoggerService} from '@/di/di.root-container.hooks';

import {useEffect, useState} from 'react';

import FontFaceObserver from 'fontfaceobserver';

import {ProjectFontFamily} from '@/constants';
import {FrontendError} from '@/services/ErrorsService/FrontendError';

interface FontLoaderParams {
  fontName: ProjectFontFamily;
  variant?: FontFaceObserver.FontVariant;
}

export const useFontLoader = ({fontName, variant}: FontLoaderParams): boolean => {
  const [fontLoaderState, setFontLoaderState] = useState(false);
  const logger = useLoggerService();

  useEffect(() => {
    const font = new FontFaceObserver(fontName, variant);

    // при любом исходе проставляем isFontLoaded: true, чтобы пользователь смог попасть на проект,
    // но, в случае ошибки загрузки шрифта, логгируем ее
    font
      .load()
      .catch((error: Error) => {
        const fontsError = FrontendError.createFontLoaderError(error);
        logger.logFontLoaderError(fontsError);
      })
      .finally(() => {
        setFontLoaderState(true);
      });
  }, [fontName, variant, logger]);

  return fontLoaderState;
};
